import { Outlet, useLocation } from "react-router-dom";
import LandingNavbar from "../Pages/LandingPage/Components/LandingNavbar";
import LandingFooter from "../Pages/LandingPage/Components/LandingFooter";
import { useAuthState } from "./GlobalContext";
import Navbar from "./Navbar";

// landing page style
// import "../SASS/plugins.scss";

function LandingLayout() {
  const AuthState = useAuthState();
  const {pathname} = useLocation();

  let isExam = false;

  if (pathname?.includes("solve-test")) {
    isExam = true;
  }


  return (
    <>
      {AuthState?.userData?.student_token ? <Navbar /> : <LandingNavbar />}

      <div className="min-h-screen h-full pt-28">
        <Outlet />
      </div>
      {!isExam && <LandingFooter />}
    </>
  );
}

export default LandingLayout;
